import React, { useState, useEffect } from "react";
import moment from "moment";
import { IoIosClose } from "react-icons/io";
import DatePicker from "react-datepicker";

const customStyles = {
	"--react-datepicker-time-list-bg": "white",
};

// const LateCheckoutTimePicker = ({
//   isModalOpen,
//   setIsModalOpen,
//   setRequestSent,
//   propertyLateCheckOutTime,
//   propertyTime,
//   checkOutDate,
//   lateCheckOutFlag,
// }) => {
//   const formattedCheckOutDate = moment(checkOutDate).isValid()
//     ? moment(checkOutDate).format("DD-MM-YYYY")
//     : moment().format("DD-MM-YYYY"); // Fallback to today's date if invalid

//   const [selectedDate, setSelectedDate] = useState(formattedCheckOutDate);
//   const [selectedTime, setSelectedTime] = useState("");
//   const [timeSlots, setTimeSlots] = useState([]);

//   // Function to generate time slots
//   const generateTimeSlots = (start, end, intervalMinutes) => {
//     const slots = [];
//     let current = new Date(start);
//     const endDate = new Date(end);

//     while (current <= endDate) {
//       slots.push(moment(current).format("hh:mm A"));
//       current.setMinutes(current.getMinutes() + intervalMinutes);
//     }

//     return slots;
//   };

//   useEffect(() => {
//     // Check if propertyTime and propertyLateCheckOutTime exist before processing
//     if (!propertyTime || !propertyLateCheckOutTime) return;

//     const [propertyHour, propertyMinute] =
//       propertyTime?.split(":").map(Number) || [];
//     const startTime = new Date();
//     startTime.setHours(propertyHour || 0, propertyMinute || 0, 0);

//     let slots = [];

//     if (propertyLateCheckOutTime.defaultTimeEnabled) {
//       const [customHour, customMinute] = propertyLateCheckOutTime.customTiming
//         ?.split(":")
//         .map(Number);

//       const endTime = new Date();
//       endTime.setHours(customHour || 0, customMinute || 0, 0);

//       slots = generateTimeSlots(startTime, endTime, 15); // 15-minute gap
//     } else {
//       const [defaultHour, defaultMinute] =
//         propertyLateCheckOutTime.defaultTiming?.split(":").map(Number) || [];

//       const endTime = new Date();
//       endTime.setHours(defaultHour || 0, defaultMinute || 0, 0);

//       slots = generateTimeSlots(startTime, endTime, 60); // 1-hour gap
//     }

//     setTimeSlots(slots);
//     setSelectedTime(slots.length > 0 ? slots[0] : "");

//     // Log to see if slots are being generated
//     console.log("Time Slots: ", slots);
//   }, [propertyTime, propertyLateCheckOutTime]);
const LateCheckoutTimePicker = ({
	isModalOpen,
	setIsModalOpen,
	setRequestSent,
	propertyLateCheckOutTime,
	propertyTime,
	checkOutDate,
	lateCheckOutFlag,
	propertyTimeZone,
	addon,
}) => {
	console.log("LateCheckoutTime Props", {
		isModalOpen,
		setIsModalOpen,
		setRequestSent,
		propertyLateCheckOutTime,
		propertyTime,
		checkOutDate,
		lateCheckOutFlag,
		propertyTimeZone,
		addon,
	});
	console.log("Setting", addon);
	const formattedCheckOutDate = moment(checkOutDate).isValid()
		? moment(checkOutDate)
				.add(1, "days")
				.format("DD-MM-YYYY") // Add 1 day to checkoutDate
		: moment().add(1, "days").format("DD-MM-YYYY"); // Fallback to the next day of today's date if invalid
	const formattedLateCheckOutDate = moment(checkOutDate).isValid()
		? moment(checkOutDate).format("DD-MM-YYYY")
		: moment().format("DD-MM-YYYY"); // Fallback to today's date if invalid

	const [selectedDate, setSelectedDate] = useState(
		lateCheckOutFlag ? formattedLateCheckOutDate : formattedCheckOutDate,
	);

	const [selectedTime, setSelectedTime] = useState("");
	const [timeSlots, setTimeSlots] = useState([]);

	// Function to generate time slots
	const generateTimeSlots = (start, end, intervalMinutes) => {
		const slots = [];
		let current = new Date(start);
		const endDate = new Date(end);

		while (current <= endDate) {
			slots.push(moment(current).format("hh:mm A"));
			current.setMinutes(current.getMinutes() + intervalMinutes);
		}

		return slots;
	};

	useEffect(() => {
		// Check if propertyTime and propertyLateCheckOutTime exist before processing
		if (!propertyTime || !propertyLateCheckOutTime) return;

		const propertyTime12 = moment(propertyTime, "HH:mm").format("hh:mm A"); // Convert propertyTime to 12-hour format
		const [propertyHour, propertyMinute] =
			propertyTime.split(":").map(Number) || [];
		const startTime = new Date();
		startTime.setHours(propertyHour || 0, propertyMinute || 0, 0);

		let slots = [];

		if (propertyLateCheckOutTime.defaultTimeEnabled) {
			const [customHour, customMinute] = propertyLateCheckOutTime.defaultTiming
				?.split(":")
				.map(Number);

			const endTime = new Date();
			endTime.setHours(customHour || 0, customMinute || 0, 0);

			slots = generateTimeSlots(startTime, endTime, 15); // 15-minute gap
		} else {
			const [defaultHour, defaultMinute] =
				propertyLateCheckOutTime.defaultTiming?.split(":").map(Number) || [];

			const endTime = new Date();
			endTime.setHours(defaultHour || 0, defaultMinute || 0, 0);

			slots = generateTimeSlots(startTime, endTime, 60); // 1-hour gap
		}

		// Filter out the propertyTime12 from the time slots
		// slots = slots.filter((slot) => slot !== propertyTime12);
		// console.log("Filtered Time Slots: ", slots);

		setTimeSlots(slots);
		setSelectedTime(slots.length > 0 ? slots[0] : "");

		// Log to see if slots are being generated
		//console.log("Time Slots: ", slots);
	}, [propertyTime, propertyLateCheckOutTime]);

	return (
		<div
			className={`fixed bottom-0 left-0 w-full bg-white px-4 py-2 shadow-lg transition-transform transform ${
				isModalOpen ? "translate-y-0" : "translate-y-full"
			} h-80`}
			style={{ zIndex: 9999 }}
		>
			<div className="flex items-center justify-between pb-4">
				<div className="text-lg text-black">
					{lateCheckOutFlag
						? "Late check-out date and time"
						: "Extend stay - select date"}
				</div>
				<button
					onClick={(e) => {
						e.preventDefault();
						setIsModalOpen(false);
					}}
					className="focus:outline-none"
				>
					<IoIosClose className="h-8 w-8 text-black" />
				</button>
			</div>
			{!lateCheckOutFlag && (
				<div className="flex items-center justify-center bg-white">
					<DatePicker
						selected={moment(selectedDate, "DD-MM-YYYY").toDate()}
						onChange={(date) =>
							setSelectedDate(moment(date).format("DD-MM-YYYY"))
						}
						placeholderText="Select Date"
						className="w-full px-10 py-3 border border-gray-400 rounded-md text-lg"
						popperClassName="custom-datepicker"
						style={customStyles}
						minDate={moment(selectedDate, "DD-MM-YYYY").toDate()}
					/>
				</div>
			)}
			{lateCheckOutFlag && (
				<div className="flex items-center justify-center bg-white">
					<input
						value={moment(selectedDate, "DD-MM-YYYY").format("MM-DD-YYYY")}
						placeholder="Select Date"
						className="w-full px-10 py-3 border border-gray-400 rounded-md text-lg text-black"
						style={customStyles}
						disabled={true}
					/>
				</div>
			)}

			{/* Display Time Slots in a Dropdown */}
			{lateCheckOutFlag && (
				<div className="mt-4 text-lg text-center">
					<div className="text-left text-black">
						Select Time: {propertyTimeZone}
					</div>
					{timeSlots.length > 0 ? (
						<select
							value={selectedTime}
							onChange={(e) => setSelectedTime(e.target.value)}
							className="w-full mt-2 px-4 py-2 border border-gray-400 rounded-md text-black"
						>
							<option value="" disabled className="text-black">
								Select Time {propertyTimeZone}
							</option>
							{timeSlots.map((slot, index) => (
								<option key={index} value={slot} className="text-black">
									{slot}
								</option>
							))}
						</select>
					) : (
						<div>No available time slots</div>
					)}
				</div>
			)}

			<button
				className="w-full py-2 mt-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50"
				onClick={(e) => {
					e.preventDefault();
					setRequestSent(selectedDate, selectedTime);
					setIsModalOpen(false);
				}}
			>
				Send Request {addon && addon.price ? `($${addon?.price})` : ""}
			</button>
		</div>
	);
};

export default LateCheckoutTimePicker;
